import React, { FC, useMemo, useEffect } from "react";
import { CalendarToolbarBuilder } from "./CalendarToolbarBuilder";
import ResourceFiltersBar from "../../commons/filters/ResourceFiltersBar";
import { ResourceType } from "../../resource/resourceType.model";
import { Floor } from "../../floor/floor.model";
import { Branch } from "../../branches/branch.model";
import { BranchReference } from "../../branches/branch.reference.model";
import { Amenity } from "../../amenities/amenity.model";
import { Paginated } from "../../commons/Paginated";
import { BranchInfo } from "../../../_services/branch.service";

interface CalendarToolbarWithFiltersProps {
  onNavigate: (action: string) => void;
  label: string;
  type: ResourceType | null;
  types: ResourceType[];
  floor: Floor | undefined;
  floors: Paginated<Floor> | null;
  branch: Branch | null;
  branches: BranchReference[];
  favoriteFloorId?: string | null;
  extra: Amenity | null;
  extras: Amenity[];
  branchInfo: BranchInfo | null;
  onNameSearch: (query: string) => void;
  onResourceTypeChange: (type: ResourceType) => void;
  onFloorChange: (floor: Floor) => void;
  onBranchChange: (branch: BranchReference) => void;
  onExtraChange: (extra: Amenity) => void;
  onFloorFavotired?: (floorId: string) => void;
}

const CalendarToolbarWithFilters: FC<CalendarToolbarWithFiltersProps> = ({
  onNavigate,
  label,
  type,
  types,
  floor,
  floors,
  branch,
  branches,
  favoriteFloorId,
  extra,
  extras,
  branchInfo,
  onNameSearch,
  onResourceTypeChange,
  onFloorChange,
  onBranchChange,
  onExtraChange,
  onFloorFavotired,
}) => {
  return (
    <CalendarToolbarBuilder
      label={label}
      onToday={() => onNavigate("TODAY")}
      onPrev={() => onNavigate("PREV")}
      onNext={() => onNavigate("NEXT")}
      children={
        types &&
        floors &&
        branch && (
          <ResourceFiltersBar
            types={types}
            type={type}
            floors={floors}
            floor={floor}
            favoriteFloorId={favoriteFloorId}
            branches={branches}
            branchInfo={branchInfo}
            branch={branch}
            extras={extras || []}
            extra={extra}
            onNameSearch={onNameSearch}
            onResourceTypeChange={onResourceTypeChange}
            onFloorChange={onFloorChange}
            onBranchChange={onBranchChange}
            onExtraChange={onExtraChange}
            onFloorFavotired={onFloorFavotired}
            smallSize={true}
            showSearchIcon={true}
          />
        )
      }
    />
  );
};

export default CalendarToolbarWithFilters;
